import { IQuickLinksTab } from './types';

export const quickLinksMock: IQuickLinksTab[] = [
  {
    title: 'Покупка',
    links: [
      { title: 'Купить квартиру', url: 'https://www.cian.ru/kupit-kvartiru/', counter: 12500 },
      { title: 'Купить квартиру', url: 'https://www.cian.ru/kupit-kvartiru/', counter: 12500 },
      { title: 'Купить квартиру', url: 'https://www.cian.ru/kupit-kvartiru/', counter: 12500 },
      { title: 'Купить квартиру', url: 'https://www.cian.ru/kupit-kvartiru/', counter: 12500 },
      { title: 'Купить квартиру', url: 'https://www.cian.ru/kupit-kvartiru/', counter: 12500 },
      { title: 'Купить новостройку', url: 'https://www.cian.ru/kupit-novostroyku/', counter: 3200 },
      { title: 'Купить нежилое', url: 'https://www.cian.ru/kupit-nezhiloe/', counter: 450 },
      { title: 'Купить нежилое', url: 'https://www.cian.ru/kupit-nezhiloe/', counter: 450 },
      { title: 'Купить нежилое', url: 'https://www.cian.ru/kupit-nezhiloe/', counter: 450 },
    ],
  },
  {
    title: 'Аренда',
    links: [
      { title: 'Снять квартиру', url: 'https://www.cian.ru/snyat-kvartiru/', counter: 8900 },
      { title: 'Снять комнату', url: 'https://www.cian.ru/snyat-komnatu/', counter: 2100 },
    ],
  },
  {
    title: 'Коммерческая',
    links: [
      { title: 'Купить нежилое', url: 'https://www.cian.ru/kupit-nezhiloe/', counter: 450 },
      { title: 'Снять офис', url: 'https://www.cian.ru/snyat-ofis/', counter: 780 },
    ],
  },
  {
    title: 'Загородная',
    links: [
      { title: 'Купить дом', url: 'https://www.cian.ru/kupit-dom/', counter: 5600 },
      { title: 'Купить участок', url: 'https://www.cian.ru/kupit-uchastok/', counter: 3400 },
    ],
  },
  {
    title: 'Дополнительно',
    links: [
      { title: 'Ипотека', url: 'https://www.cian.ru/ipoteka/', counter: 1200 },
      { title: 'Оценка квартиры', url: 'https://www.cian.ru/otsenka-kvartiry/', counter: 340 },
    ],
  },
];
